import "./App.css";
import React, { useEffect, useState } from "react";
import { View, Text, Dimensions } from "react-native";
import { BreakpointsProvider } from "rn-responsive-styles"
import ModalAlert from "./common/ModalAlert";
import {  getPaymentStatus } from "./api/serviceRequest";
import { getConfigurations } from "./api/serviceRequest";
import { createTIPolicy } from "./api/tripInsurance";
import AsyncStorageFunc from './utilities/asyncStorage';
import AppNavigation from "./navigation"
import {jwtDecode} from "jwt-decode";
import LoginProvider from "./context/loginProvider";
import { v4 as uuidv4 } from 'uuid';  
import { ApiProvider } from "./api/ApiContext";
import CWelcomePopup from "./common/CWelcomePopup";


function App() {
  const outsideAuth = ["/login","/loginbyvrnscreen","/responsescreen","/activateuser","/unlockuserscreen","/selectunlockscreen","/checktagbalance","/selectforgotscreen","/forgotuserscreen","/forgotpasswordscreen"]
  if(outsideAuth.includes( window?.location?.pathname?.toLowerCase())){
    global.prevRoute = "/Home"
  }else{
    global.prevRoute = window.location.pathname
  }
console.log("routes res app",global.prevRoute)
  const [routeName, setRouteName] = useState(false)
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [data, setData] = useState();
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (history.pushState) {
      history.pushState(null, document.title, location.href);
      window.addEventListener("popstate", function (event) {
        history.pushState(null, document.title, location.href);
      });
    }
  }, []);

  useEffect(() => {
    loadDefaultConfig();
    AsyncStorageFunc.getData("TOKEN").then((token) => {
      console.log(token,'app token')
      if (token && token != "") {
        setRouteName(!routeName)
        let loginData = jwtDecode(token);
        global.token =  token;
        global.userId = loginData.userId;
        global.userCd = loginData.userCd;
        global.fullName = loginData.fullName ? loginData.fullName : "";
        global.userType = loginData.userType;
        global.welcomeConfigEvents = [];
      } else {
      }
    })
    AsyncStorageFunc.getData("deviceId").then((deviceId) => {
      if (!deviceId) {
        let localDeviceId = uuidv4()
        deviceId = localDeviceId
        AsyncStorageFunc.storeData("deviceId", deviceId)
      }
    }).catch(err => err)
  }, [])

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  const onCloseModal = () => {
    if(alertModal.navigateScreen == "trip insurance"){
      setAlertModalVisible(false)
      _createTIPolicy()
    }else{
      setAlertModalVisible(false);
    }
  };

  const loadDefaultConfig = () => {
    
      getConfigurations().then((res)=>{
        if(res.statusCode == 200) {

          let SINGLE_FILE_SIZE_LIMIT = res?.data.filter(val => val.key == "SINGLE_FILE_SIZE_LIMIT")
          let KYC_SINGLE_FILE_SIZE_LIMIT = res?.data.filter(val => val.key == "KYC_FILE_SIZE_LIMIT")

          let maxFileSize = SINGLE_FILE_SIZE_LIMIT[0].value/1024
          let kycMaxFileSize = KYC_SINGLE_FILE_SIZE_LIMIT[0].value/1024 
          
          global.maxUploadFileSizeInMB = maxFileSize
          global.kycMaxUploadFileSizeInMB = kycMaxFileSize
          const tripClaimContactInfoObj = res?.data.find((configItem) => configItem.key == "tripClaimContactInfo");
          const tripIsnpReferenceNo = res?.data.find((configItem) => configItem.key == "trip_isnp_reference_no");
          const ifscRegex = res?.data.find((configItem) => configItem.key == "ifscCodeRegex");
          const welcomeConfigEventsObj =  res?.data.find((configItem) => configItem.key == "welcome-config-key");
          const ccavenueAccessCode =res?.data.find((configItem) => configItem.key == "ccavenue_access_code_ff_portal");
          const CC_AVENUE_URL =res?.data.find((configItem) => configItem.key == "CC_AVENUE_URL");
          const AUTO_RECHARGE_APPLY_LINK =res?.data.find((configItem) => configItem.key == " AUTO_RECHARGE_APPLY_LINK");
          const CC_EMAIL = res?.data.find((configItem) => configItem.key == "CC_EMAIL");
          const CC_CONTACT  = res?.data.find((configItem) => configItem.key == "CC_CONTACT");
          const MAX_VRN_COUNT_PORTAL_STMT  = res?.data.find((configItem) => configItem.key == "MAX_VRN_COUNT_PORTAL_STMT");
          const used_car_loan_url  = res?.data.find((configItem) => configItem.key == "used_car_loan_url");
          const recharge_not_allowed  = res?.data.find((configItem) => configItem.key == "rechargeNotAllowed");
          const maxProductValue = res?.data.find((configItem) => configItem.key == "MAX_PRODUCT_VALUE");
          const statement_filter_days = res?.data.find((configItem) => configItem.key == "statement_filter_days");


          if (CC_EMAIL) {
            global.CC_EMAIL = CC_EMAIL.value;
          }
          if (MAX_VRN_COUNT_PORTAL_STMT) {
            global.MAX_VRN_COUNT_PORTAL_STMT = MAX_VRN_COUNT_PORTAL_STMT.value;
          }
          if (CC_CONTACT) {
            global.CC_CONTACT = CC_CONTACT.value;
          }
          if (CC_AVENUE_URL) {
            global.CC_AVENUE_URL = CC_AVENUE_URL.value;
          }
          if (AUTO_RECHARGE_APPLY_LINK) {
            global.AUTO_RECHARGE_APPLY_LINK = AUTO_RECHARGE_APPLY_LINK.value;
          }
        if (ccavenueAccessCode) {
          global.ccavenueAccessCode = ccavenueAccessCode.value;
        }
        if (tripClaimContactInfoObj) {
          global.tripClaimContactInfo = tripClaimContactInfoObj.value;
        }
        if (tripIsnpReferenceNo) {
          global.tripIsnpReferenceNo = tripIsnpReferenceNo.value;
        }
        if (ifscRegex) {
          global.ifscRegex = ifscRegex.value;
        }
        if (welcomeConfigEventsObj && welcomeConfigEventsObj.value) {
          global.welcomeConfigEvents = welcomeConfigEventsObj.value.split(',');
        }
        if (used_car_loan_url) {
          global.UCLURL = used_car_loan_url.value;
        }
        if (recharge_not_allowed) {
          global.recharge_not_allowed = recharge_not_allowed.value.split(',');
        }
        if(maxProductValue){
          global.maxProductValue = maxProductValue.value.split(',');
        }
        if(statement_filter_days){
          global.statement_filter_days = statement_filter_days.value;
        }
        }
      }).catch((err)=>{
        global.maxUploadFileSizeInMB = 2
        global.kycMaxUploadFileSizeInMB = 1
      })
  }

  var getPaymentKey = getParameterByName('apiStatus')
  useEffect(() => {
    if (getPaymentKey == "SUCCESS") {
      AsyncStorageFunc.getData('ORDERID').then((orderId) => {
        setLoading(true);
        getPaymentStatus({
          orderId: orderId,
          mobileNo: ""
        })
          .then(res => {
            setLoading(false);
            if (res.statusCode == -1038 || res.statusCode == -1037 || res.statusCode == 500) {
              setAlertModal({
                title: "Error",
                status: "error",
                message: res.message,
                navigateScreen: "",
                actionButton: "OK"
              });
              setAlertModalVisible(true);
            }
            if (res.statusCode == 1038 || res.statusCode == 1037) {
              setAlertModal({
                title: "Successful",
                status: "success",
                message: res.message,
                navigateScreen: "trip insurance",
                actionButton: "OK"
              });
              setData(res?.data)
              setAlertModalVisible(true);
              setLoading(false)
            }
          })
          .catch(err => {
            setLoading(false);
            setAlertModal({
              title: "Error",
              status: "error",
              message: err.message,
              navigateScreen: "",
              actionButton: "OK"
            });
            setAlertModalVisible(true);
          });
      })
    }
  }, [getPaymentKey])


  const _createTIPolicy = () => {
    AsyncStorageFunc.getData('TI_REQ').then((params) => {
      if(!params.isInsuranceSkipped){
        let reqObj = {
          mobileNo: params?.mobileNo,
          tagId: params?.tagId == "" ? data.tagId : params?.tagId,
          triggeringMode: params?.triggeringMode,
          policyInfo:params?.policyInfo,
          insuredDetails: params?.insuredDetails,
          nomineeDetails: params?.nomineeDetails,
        };
       delete params.isInsuranceSkipped
      setLoading(true);
      createTIPolicy(reqObj)
        .then(res => {
          setLoading(false);
          if (res.statusCode == 1092) {
            setAlertModal({
              title: "Successful",
              status: "success",
              message: res.message,
              navigateScreen: "",
              actionButton: "OK"
            });
             AsyncStorageFunc.storeData('TI_REQ',{})
            setAlertModalVisible(true);
            setLoading(false)
          }
          else {
            setAlertModal({
              title: "Error",
              status: "error",
              message: res.message,
              navigateScreen: "",
              actionButton: "OK"
            });
            setAlertModalVisible(true);
          }
        })
        .catch(err => {
          setLoading(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: err.message,
            navigateScreen: "",
            actionButton: "OK"
          });
          setAlertModalVisible(true);
        });
      }
    })
  }
  useEffect(() => { 
    // define increment counter part
    const tabsOpen = localStorage.getItem("tabsOpen");
    if (tabsOpen == null) {
      localStorage.setItem("tabsOpen", 1);
    } else {
      localStorage.setItem("tabsOpen", parseInt(tabsOpen) + parseInt(1));
    }
    // define decrement counter part
    window.onbeforeunload = (e) => {
      const newTabCount = localStorage.getItem("tabsOpen");
      if (newTabCount !== null) {
        localStorage.setItem("tabsOpen", newTabCount - 1);
      }
    };
    if (window.performance.navigation.type == 1) {
      window.localStorage.isMySessionActive = "false";
    } else {
      const newTabCount2 = localStorage.getItem("tabsOpen");
      let value = localStorage.getItem("isMySessionActive");
      if (value == "true") {
        if (newTabCount2 == 1) {
          AsyncStorageFunc.deleteData('TOKEN').then((tokenRes) => {})
          window.localStorage.isMySessionActive = "false";
        } else {
          window.localStorage.isMySessionActive = "false";
        }
      }
    }
    return () => {
      const newTabCount = localStorage.getItem("tabsOpen");
      if (newTabCount !== null) {
        localStorage.setItem("tabsOpen", newTabCount - 1);
      }
    }
  }, []);


  return (

    <BreakpointsProvider breakpoints={[1199, 1023, 767, 539]}>
      <>
        
        <LoginProvider >
        <ApiProvider>
          <AppNavigation routeName={routeName} />
          </ApiProvider>
        </LoginProvider>
        <CWelcomePopup />
        {alertModalVisible && (
          <View style={{
            position: "absolute",
            zIndex: 9999,
            backgroundColor: "rgba(52,52,52,0.9)",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            borderRadius: 10,
          }}>
            <ModalAlert
              title={alertModal.title}
              status={alertModal.status}
              message={alertModal.message}
              navigateScreen={alertModal.navigateScreen}
              actionButton={"OK"}
              onCloseModal={onCloseModal}
            />
          </View>
        )}
      </>
    </BreakpointsProvider>
  );
}

export default App;


